import React, {useEffect, useState } from 'react'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import MailOutlinedIcon from '@mui/icons-material/MailOutlined'
import CallOutlinedIcon from '@mui/icons-material/CallOutlined'
import AOS from "aos";
import "aos/dist/aos.css";
import "animate.css";
import { Link } from 'react-router-dom'
import shape from '../assets/Images/shapes/HomecardsThread-01.png'
import BookAppointmentDialog from './BookAnAppointmentDialogue'
export default function HomeCards () {
  const [dialogOpen, setDialogOpen] = useState(false);
  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };
  useEffect(() => {
    AOS.init({
      duration: 1000, 
      once: true, 
    });
  }, []);
  return (
    <div>
      <div className=' pt-[90px] md:pt-[230px] relative pb-[62px] md:pb-[240px]'>
        <div className='max-w-[1340px] mx-auto  md:px-[24px] xl:px-[0px] px-3 ' data-aos="fade-up">
          <div className='z-[1]'>
            <h2 className=' text-[36px] md:text-[58px] leading-[1.138em] font-heading text-thickGreen max-w-[530px] mb-[48px]'>
            Schedule an in-person or virtual consultation
            </h2>
            <div className='flex flex-col xl:flex-row gap-3 xl:gap-[28px]'>
              <div className='xl:w-2/3 w-full flex md:flex-row flex-col gap-3 xl:gap-[28px]'>
              <div className='bg-lightOrange py-[48px] px-[32px]  rounded-[24px] md:w-1/2 w-full '>
                <h3 className='text-[28px]  font-heading leading-[1.429em] text-thickGreen mb-[24px]'>
                  Visit us on
                </h3>
                <div className='flex gap-1'>
                  <LocationOnIcon className='text-orange mb-[18px] text-[25px]' />
                  <div className='text-[20px] font-medium leading-[1.111em] font-body text-paraGreen'>
                  Yousufguda Main Rd., Yella Reddy Guda,
                  </div>
                </div>
                <Link to='https://maps.app.goo.gl/6CFV19BqFjLMULLEA' target='_blank'><div className='flex gap-3 text-orange  items-center'>
                  <div className='text-[20px] leading-[1.111em] font-body p-3'>
                    Open on Google Maps
                  </div>
                  <ArrowForwardIcon className='font-bold text-[18px] leading-[1.111em] font-body' />
                </div></Link>
                <div className='my-[40px] h-[1px] bg-[#c4d6d6]'></div>
                <div className='flex flex-col gap-y-[18px]'>
                  <div className='flex gap-2 text-[20px] font-body'>
                    <AccessTimeIcon className='text-orange' />
                    <div className='text-paraGreen'>
                      Mon - Fri: 8:00am to 5:00pm
                    </div>
                  </div>
                  <div className='flex gap-2 text-[20px] font-body'>
                    <AccessTimeIcon className='text-orange' />
                    <div className='text-paraGreen'>
                      Mon - Fri: 8:00am to 5:00pm
                    </div>
                  </div>
                  <div className='flex gap-2 text-[20px] font-body'>
                    <AccessTimeIcon className='text-orange' />
                    <div className='text-paraGreen'>
                      Mon - Fri: 8:00am to 5:00pm
                    </div>
                  </div>
                </div>
              </div>

             
              <div className='bg-lightOrange py-[48px] px-[32px] rounded-[24px] md:w-1/2 w-full'>
                <h3 className=' font-heading text-[28px] leading-[1.429em] text-thickGreen mb-[16px]'>
                Book your appointment at
                </h3>
                <div className='flex gap-2 mb-[12px]'>
                  <MailOutlinedIcon className='text-orange text-[12px]' />
                  <div className='text-paraGreen font-body text-[20px] font-medium'>
                    Email address
                  </div>
                </div>
                <div className='text-thickGreen font-body text-[22px] leading-[1.273em] font-medium flex flex-col'>
                  <Link to='mailto:info@magnaid.com' className='my-3'>info@magnaid.com</Link>
                  <Link to='mailto:magnaidhospitals@gmail.com'>magnaidhospitals@gmail.com</Link>
                </div>
                <div className='my-[40px] h-[1px] bg-[#c4d6d6]'></div>
                <div className='flex gap-2 mb-[12px]'>
                  <CallOutlinedIcon className='text-orange text-[12px]' />
                  <div className='text-paraGreen font-body text-[20px] font-medium'>
                    Phone number
                  </div>
                </div>
                <div className='text-thickGreen font-body text-[22px] leading-[1.273em] font-medium mb-3'>
                  <Link to='tel:79939 99040'>7993 999 040</Link>
                </div>
                <div className='text-thickGreen font-body text-[22px] leading-[1.273em] font-medium'>
                  <Link to='tel:79939 99044'>7993 999 044</Link>
                </div>
                
              </div>
              </div>
          
              <div className='bg-lightOrange py-[48px] px-[32px] rounded-[24px] w-full xl:w-1/3'>
                <h3 className='text-[28px]  text-thickGreen font-heading leading-[1.429em] mb-[24px]'>
                Seamless online Consultation
                </h3>
                <p className='mb-[24px] text-paraGreen text-[20px] font-body font-medium leading-[1.667em]'>
                Book an appointment quickly anytime and  from anywhere through our website else give us a call.
                </p>
                <button
                   onClick={handleOpenDialog}
                  className='bg-orange text-white px-12 py-6 rounded-full font-medium   font-body text-[20px] leading-[1.112em] 
       transition-all duration-300 hover:bg-lightGreen  hover:bg-opacity-90 
       hover:translate-y-[-3px] block md:inline-block text-center mt-16'
                >
                  Book an Appointment
                </button>
              </div>
            </div>
          </div>
        </div>
        <img
          src={shape}
          loading='eager'
          alt='shape' 
          className='absolute top-[17%] md:top-[20%] left-[25%] md:left-[40%] z-[-1] animate__animated animate__fadeIn animate__delay-1s'
        />
      </div>
      <BookAppointmentDialog open={dialogOpen} onClose={handleCloseDialog} />
    </div>
  )
}
